module.exports = __webpack_public_path__ + "static/media/perfil_viejo.e0b7992b.svg";